export enum ProductDepartmentEnum {
    Bundles = 1,
    Plugins = 2,
    General = 5,
    Books = 6,
    InactiveItems = 7,
    LiveSound = 8,
    Hardware = 9,
    Software = 10,
    Subscription = 12,
    Consumer = 13,
    RentToOwnDynamic = 14,
    RentToOwnStatic = 15,
    Merch = 16,
    WavesUpdatePlan = 17,
    Upgrades = 18,
    Courses = 19,
    SubscriptionDynamic = 20,
    Gifts = 21,
    CoursesWithSoftware = 22,
    SubscriptionNonRecurring = 23,
    Mastering = 24,
    SampleMakerExtraCredits = 25,
    SampleMakerSubscriptions = 26,
    VoiceRegenSubscriptions = 27,
}